import React from 'react';
import {
  CheckCircleOutlined,
  CloseCircleOutlined,
  ExclamationCircleOutlined,
  SyncOutlined,
  WarningOutlined
} from '@ant-design/icons';

export const STATUS_CONFIGS = {
  unavailable: {
    status: 'unavailable',
    text: 'Status Unavailable',
    icon: <ExclamationCircleOutlined />,
    color: '#889AAA',
    badgeStatus: 'default',
    alertType: 'error'
  },
  loading: {
    status: 'loading',
    text: 'Loading...',
    icon: <SyncOutlined spin />,
    color: '#8c8c8c',
    badgeStatus: 'processing',
    alertType: 'info'
  },
  operational: {
    status: 'operational',
    text: 'All Systems Operational',
    icon: <CheckCircleOutlined />,
    badgeStatus: 'processing',
    color: 'green',
    alertType: 'success'
  },
  critical: {
    status: 'critical',
    text: 'Service Degradation',
    icon: <CloseCircleOutlined />,
    badgeStatus: 'error',
    alertType: 'error'
  },
  partial: {
    status: 'partial',
    text: 'Partial Service Degradation',
    icon: <WarningOutlined />,
    badgeStatus: 'warning',
    alertType: 'warning'
  }
};
